document.addEventListener('DOMContentLoaded', function () {
    const sideCart = document.getElementById('side-cart');
    const overlay = sideCart?.querySelector('.side-cart-overlay');
    const closeBtn = document.getElementById('close-side-cart');
    const itemsContainer = document.getElementById('side-cart-items');
    const openSideCartBtn = document.querySelectorAll('.icon-open-cart-PDM');
    const upsellSwiperElement = document.querySelector('.upsell-swiper');
    const body = document.querySelector('body');

    //Upsell elements
    let productsCollection = [];
    const collectionHandle = 'tools-accessories';
    
    if (upsellSwiperElement) {

      fetch(`${window.Shopify.routes.root}collections/${collectionHandle}/products.json`)
        .then(response => response.json())
        .then(data => {
          productsCollection = data.products;
        })
        .catch(error => console.error('Error al obtener los productos de la colección:', error));

    };

    //Function build the upsell component
    function buildUpsellCarrousel() {
      const upsellSwiperElement = document.querySelector('.upsell-swiper');
      const swiperWrapper = upsellSwiperElement.querySelector('.swiper-wrapper');
      swiperWrapper.innerHTML = '';
      let foundRecommendations = false;

      const fetchRecommendations = async (productId) => {
        const response = await fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=10&intent=complementary`);
        const data = await response.json();
        return data.products;
      };

      function createUpsellHTML(productsInUpsell, number, number2) {
        const fragment = document.createDocumentFragment(); 

        productsInUpsell.forEach((product, index) => {

          const src = product?.variants?.[0]?.featured_image?.src;
          if (src) {
          
            // Create main element of slide
            const swiperSlide = document.createElement('div');
            swiperSlide.classList.add('swiper-slide');
            swiperSlide.setAttribute('data-variant-id', product.id);
            swiperSlide.setAttribute('data-loop', index);

            // Crate upsell card
            const upsellCard = document.createElement('div');
            upsellCard.classList.add('upsell-card');

            // Content container
            const contentCard = document.createElement('div');
            contentCard.classList.add('content-card');

            // Product image
            const productImage = document.createElement('img');
            console.log(product.variants[0].featured_image.src);
            productImage.src = number === 1 ? product.variants[0].featured_image.src : product.featured_image;
            productImage.alt = product.title;
            productImage.style.width = '76px';
            productImage.style.height = '76px';
            productImage.style.borderRadius = '6.877px';

            // Container title and variants
            const containerTitleVariant = document.createElement('div');
            containerTitleVariant.classList.add('container-title-variant');

            // Product title
            const productTitle = document.createElement('h4');
            productTitle.textContent = product.title;

            // Container select
            const customSelect = document.createElement('div');
            customSelect.classList.add('custom-select');
            if (product.variants.length < 2 || product.options.length > 1) {
              customSelect.classList.add('hide');
            }

            // Btn of select
            const selectButton = document.createElement('button');
            selectButton.id = 'dropdown-button';
            selectButton.classList.add('select-button');
            selectButton.setAttribute('role', 'combobox');
            selectButton.setAttribute('aria-label', 'select button');
            selectButton.setAttribute('aria-haspopup', 'listbox');
            selectButton.setAttribute('aria-expanded', 'false');
            selectButton.setAttribute('aria-controls', 'select-dropdown');

            const selectedValue = document.createElement('span');
            selectedValue.classList.add('selected-value');

            const selectedValueColor = document.createElement('div');
            selectedValueColor.classList.add('selected-value-color');
            selectedValueColor.style.backgroundImage = `url('https://cdn.shopify.com/s/files/1/0056/4749/9310/files/color-${product.variants[0].title.toLowerCase()}.png?v=1613719602')`;
            selectedValueColor.style.backgroundSize = 'cover';
            selectedValueColor.style.backgroundPosition = 'center';

            selectedValue.appendChild(selectedValueColor);
            selectedValue.appendChild(document.createTextNode(product.variants[0].title));
            selectButton.appendChild(selectedValue);

            // Variants Dropdown
            const selectDropdown = document.createElement('ul');
            selectDropdown.classList.add('select-dropdown', 'hidden-dropdown');
            selectDropdown.setAttribute('role', 'listbox');
            selectDropdown.id = 'select-dropdown';
            selectDropdown.setAttribute('aria-labelledby', 'dropdown-button');

            product.variants.forEach(variant => {
              const variantOption = document.createElement('li');
              variantOption.setAttribute('role', 'option');
              variantOption.setAttribute('data-variant-id', variant.id);
              variantOption.setAttribute('data-available', variant.available);
              const cleanPrice = String(variant.price).replace(/\./g, '');
              variantOption.setAttribute('data-price', cleanPrice);
              variantOption.setAttribute('data-img-src', variant.featured_image ? variant.featured_image.src : '');

              if (!variant.available) {
                variantOption.classList.add('disabled');
              };

              const variantColor = document.createElement('div');
              variantColor.classList.add('selected-value-color');
              variantColor.style.backgroundImage = `url('https://cdn.shopify.com/s/files/1/0056/4749/9310/files/color-${variant.title.toLowerCase()}.png?v=1613719602')`;
              variantColor.style.backgroundSize = 'cover';
              variantColor.style.backgroundPosition = 'center';

              variantOption.appendChild(variantColor);
              variantOption.appendChild(document.createTextNode(variant.title));
              selectDropdown.appendChild(variantOption);
            });

            // Add SVG icon after selecetedValue
            const arrowIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            arrowIcon.setAttribute('class', 'arrow');
            arrowIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            arrowIcon.setAttribute('width', '13');
            arrowIcon.setAttribute('height', '12');
            arrowIcon.setAttribute('viewBox', '0 0 13 12');
            arrowIcon.setAttribute('fill', 'none');

            const gElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
            gElement.setAttribute('clip-path', 'url(#clip0_2002_158)');

            const pathElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            pathElement.setAttribute('d', 'M10.1572 4.5L6.40723 8.25L2.65723 4.5');
            pathElement.setAttribute('stroke', '#170B32');
            pathElement.setAttribute('stroke-width', '1.5');
            pathElement.setAttribute('stroke-linecap', 'round');
            pathElement.setAttribute('stroke-linejoin', 'round');

            gElement.appendChild(pathElement);
            arrowIcon.appendChild(gElement);

            const defsElement = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
            const clipPathElement = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
            clipPathElement.setAttribute('id', 'clip0_2002_158');

            const rectElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            rectElement.setAttribute('width', '12');
            rectElement.setAttribute('height', '12');
            rectElement.setAttribute('fill', 'white');
            rectElement.setAttribute('transform', 'translate(0.407227)');

            clipPathElement.appendChild(rectElement);
            defsElement.appendChild(clipPathElement);
            arrowIcon.appendChild(defsElement);

            selectButton.appendChild(arrowIcon);
            customSelect.appendChild(selectButton);
            customSelect.appendChild(selectDropdown);

            // Btn add to cart
            const addToCartButton = document.createElement('div');
            addToCartButton.classList.add('btn-add-to-cart');
            if (!product.variants[0].available) {
              addToCartButton.classList.add('disabled');
            }
            addToCartButton.setAttribute('data-variant-id', product.variants[0].id);

            const addToCartText = document.createElement('p');
            addToCartText.textContent = product.variants[0].available
              ? `ADD TO CART - $${number2 === 1 
                  ? new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(product.variants[0].price / 100) 
                  : product.variants[0].price}`
              : 'OUT OF STOCK';

            addToCartButton.appendChild(addToCartText);

            // Build structure
            containerTitleVariant.appendChild(productTitle);
            containerTitleVariant.appendChild(customSelect);

            contentCard.appendChild(productImage);
            contentCard.appendChild(containerTitleVariant);

            upsellCard.appendChild(contentCard);
            upsellCard.appendChild(addToCartButton);

            swiperSlide.appendChild(upsellCard);

            // Add fragment into slide
            fragment.appendChild(swiperSlide);
          }
        });

        return fragment;
      }

      function resetSwiper() {
        const upsellSwiperElement = document.querySelector('.upsell-swiper');
        if (upsellSwiperElement && upsellSwiperElement.swiper) {
          upsellSwiperElement.swiper.destroy(true, true);

        }
        initSwiper();
      }

      function initSwiper() {
        const upsellSwiperElement = document.querySelector('.upsell-swiper');
        const swiperWrapper = upsellSwiperElement.querySelector('.swiper-wrapper');
        const slides = swiperWrapper.querySelectorAll('.swiper-slide');

        // Limitar el número de slides a 5
        if (slides.length > 5) {
          slides.forEach((slide, index) => {
            if (index >= 5) {
              slide.remove();
            }
          });
        };

        const upsellSwiper = new Swiper('.upsell-swiper', {
          slidesPerView: 1,
          spaceBetween: 16,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          loop: true
        });
      }

      function initSelectors() {
        const customSelects = document.querySelectorAll(".custom-select");

        customSelects.forEach((customSelect) => {
          const selectButton = customSelect.querySelector(".select-button");
          const dropdown = customSelect.querySelector(".select-dropdown");
          const options = dropdown.querySelectorAll("li");
          const selectedValue = selectButton.querySelector(".selected-value");
          const upsellCard = customSelect.closest('.upsell-card');
          let buttonAddToCart;
          if(upsellCard){
            buttonAddToCart = upsellCard.querySelector('.btn-add-to-cart');
          }

          let focusedIndex = -1; 
          
          if(buttonAddToCart){
            buttonAddToCart.addEventListener('click', function () {
              const variantId = parseInt(buttonAddToCart.getAttribute('data-variant-id'));
              const quantity = 1;

              const formData = {
                items: [{
                  id: variantId,
                  quantity: quantity
                }]
              };

              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
                .then(response => {
                  if (!response.ok) {
                    throw new Error('Error al agregar al carrito');
                  }
                  return response.json();
                })
                .then(data => {
                  buildUpsellCarrousel();
                  updateContentCart();
                  updateCount();
                })
                .catch((error) => {
                  console.error('Error:', error);
                  alert('No se pudo agregar al carrito');
                });
            });
          }

          

          const toggleDropdown = (expand = null) => {
            const isOpen =
              expand !== null ? expand : dropdown.classList.contains("hidden-dropdown");
            dropdown.classList.toggle("hidden-dropdown", !isOpen);
            selectButton.setAttribute("aria-expanded", isOpen);

            if (isOpen) {
              focusedIndex = [...options].findIndex((option) =>
                option.classList.contains("selected")
              );
              focusedIndex = focusedIndex === -1 ? 0 : focusedIndex;
              updateFocus();
            } else {
              focusedIndex = -1;
              selectButton.focus();
            }
          };
          
          const updateFocus = () => {
            options.forEach((option, index) => {
              if (option) {
                option.setAttribute(
                  "tabindex",
                  index === focusedIndex ? "0" : "-1"
                );
                if (index === focusedIndex) option.focus();
              }
            });
          };

          const handleOptionSelect = (option) => {
            options.forEach((opt) => opt.classList.remove("selected"));
            option.classList.add("selected");
            selectedValue.innerHTML = option.innerHTML;

            if (option.dataset.value === "clear") {
              selectedValue.textContent = "Open this select menu";
              options.forEach((opt) => opt.classList.remove("selected"));
              return;
            }
          };

          const changeVariantCta = (option) => {
            const variantId = option.getAttribute("data-variant-id");
            const variantPrice = option.getAttribute("data-price");
            const isAvailable = option.getAttribute("data-available") === 'true';
            buttonAddToCart.setAttribute("data-variant-id", variantId);
            buttonAddToCart.querySelector('p').textContent = isAvailable 
              ? `ADD TO CART - $${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(variantPrice / 100)}` 
              : 'Out Of Stock';
            
            if (isAvailable) {
              buttonAddToCart.classList.remove('disabled');
            } else {
              buttonAddToCart.classList.add('disabled');
            }
          };

          const changeImage = (option) => {
            const imageSrc = option.getAttribute("data-img-src");
            const productImage = upsellCard.querySelector('.content-card img');
            if (imageSrc) {
              productImage.src = imageSrc;
            } else {
              productImage.src = number === 1 ? product.images[0].src : product.featured_image;
            }
          };

          options.forEach((option) => {
            option.addEventListener("click", () => {
              handleOptionSelect(option);
              toggleDropdown(false);
              changeVariantCta(option);
              changeImage(option);
            });
          });

          selectButton.addEventListener("click", () => {
            toggleDropdown();
          });

          selectButton.addEventListener("keydown", (event) => {
            if (event.key === "ArrowDown") {
              event.preventDefault();
              toggleDropdown(true);
            } else if (event.key === "Escape") {
              toggleDropdown(false);
            }
          });

          dropdown.addEventListener("keydown", (event) => {
            if (event.key === "ArrowDown") {
              event.preventDefault();
              focusedIndex = (focusedIndex + 1) % options.length;
              updateFocus();
            } else if (event.key === "ArrowUp") {
              event.preventDefault();
              focusedIndex = (focusedIndex - 1 + options.length) % options.length;
              updateFocus();
            } else if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              handleOptionSelect(options[focusedIndex]);
              toggleDropdown(false);
            } else if (event.key === "Escape") {
              toggleDropdown(false);
            }
          });
        });
      }

      fetch('/cart.js')
        .then(response => response.json())
        .then(async cart => {
          const cartItems = cart.items;
          const sortedCartItems = [...cartItems].sort((a, b) => b.final_line_price - a.final_line_price);

          if(cartItems.length == 0) {
            const containerUpsell = document.querySelector('.container-upsell');
            if(!containerUpsell.classList.contains('hide')) {
              containerUpsell.classList.add('hide');
            }
          }else {
            const containerUpsell = document.querySelector('.container-upsell');
            if(containerUpsell.classList.contains('hide')) {
              containerUpsell.classList.remove('hide');
            }
            for (const item of sortedCartItems) {
                const productId = item.product_id;
                const productsInUpsell = await fetchRecommendations(productId);
              if (productsInUpsell.length > 0){
                let numberRef = 0;
                console.log(productsInUpsell)
                if(productsInUpsell[0].variants[0].featured_image == null){
                  console.log('No variante');
                  numberRef = 0;
                }else{
                  console.log('Si variante');
                  numberRef = 1;
                  console.log(productsInUpsell[0].variants[0].featured_image.src);
                }
                foundRecommendations = true;
                const upsellHTML = createUpsellHTML(productsInUpsell, numberRef, 1);
                swiperWrapper.appendChild(upsellHTML);
                resetSwiper();
                initSelectors();
                break;
              }
            }
            if (!foundRecommendations) {
              productsCollection = productsCollection.filter(product => {
                return !cartItems.some(item => item.product_id === product.id);
              });
              const upsellHTML = createUpsellHTML(productsCollection, 1, 0);
              swiperWrapper.appendChild(upsellHTML);
              resetSwiper();
              initSelectors();
            };
          }
        })
        .catch(error => console.error('Error al obtener el carrito:', error));
    };
  
    // Function to open side cart
    function openSideCart() {
      sideCart?.classList.add('open');
      sideCart?.classList.remove('hidden');
      body.classList.add('cart-open');
      updateContentCart();
      updateCount();
      togglePSWidget();
      buildUpsellCarrousel();
    }
  
    // Function to hide the PS widget
    function togglePSWidget() {
      const psWidget = document.querySelector('#ps__widget');
      if (psWidget) {
        psWidget.classList.toggle('hidden');
      }
    }
  
    //Function to update content side cart
    function updateContentCart(){
      fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (!itemsContainer) return;
        itemsContainer.innerHTML = cart.items.map(item => `
          <div class="cart-item-side-cart" data-line="${item.id}">
            <img class="item-image-side-cart" src="${item.image}" alt="${item.title}" width="50">
            <div class="item-info-side-cart">
              <p class="item-info-side-cart-title">${item.product_title}</p>
              <p class="item-info-side-cart-variant">
                ${item.options_with_values[0].name != "Title" 
                  ? `${item.options_with_values[0].name}: <span>${item.options_with_values[0].value}</span>` 
                  : ''}
              </p>
            </div>
            <div class="item-selectors-side-cart">
              <select id="quantity-item-side-cart" name="quantity" data-id="${item.id}">
                ${[...Array(10)].map((_, i) => {
                  const value = i + 1;
                  return `<option value="${value}" ${item.quantity === value ? 'selected' : ''}>${value}</option>`;
                }).join('')}
              </select>
              <div class="item-side-cart-price">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.final_price / 100)}</div>
              <svg class="item-icon-remove" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_2704_489)">
                  <path d="M15 9L9 15" stroke="#565656" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 9L15 15" stroke="#565656" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#565656" fill-opacity="0.2"/>
                </g>
                <defs>
                  <clipPath id="clip0_2704_489">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div class="cart-item-side-cart-mobile" data-line="${item.id}">
            <img class="item-image-side-cart" src="${item.image}" alt="${item.title}" width="50">

            <div class="container-info-side-cart-mobile">
              <p class="item-title-side-cart">${item.product_title}</p>
              <p class="item-info-side-cart-variant">
                ${item.options_with_values[0].name != "Title" 
                  ? `${item.options_with_values[0].value}` 
                  : ''}
              </p>
              <div class="item-additional-info">
                
                <div class="container-quantity-price">
                  <div class="quantity-selector">
                    <div class="btn-quantity btn-quantity--decrease">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8 12H16" stroke="#535353" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div id="quantity-item-side-cart" data-quantity="${item.quantity}" data-id="${item.id}">${item.quantity}</div>
                    <div class="btn-quantity btn-quantity--increase">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8 12H16" stroke="#535353" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 8V16" stroke="#535353" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                  </div>
                  <div class="container-prices">
                    ${item.original_price !== item.final_price 
                      ? `<div class="item-side-cart-price-original">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.original_price / 100)}</div>` 
                      : ''}
                    <div class="item-side-cart-price">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(item.final_price / 100)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `).join('');
      });
    }
  
    // Function to close side cart
    function closeSideCart() {
      sideCart?.classList.remove('open');
      sideCart?.classList.add('hidden');
      body.classList.remove('cart-open');
      updateCount();
      reActivateAddToCartBtn();
      togglePSWidget();
    }
  
    //Function to update content cart when the cart is updated
    function updateCount() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          refreshCartUI(cart);
        })
        .catch((error) => {
          console.error('Error al obtener los datos del carrito:', error);
        });
    }
  
    // Function to update cart item quantity
    function updateCartItemQuantity(line, quantity, validation) {
      const payload = {
        updates: {}
      };
      payload.updates[line] = quantity;
    
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(res => res.json())
        .then(cart => {
          refreshCartUI(cart);
          if (validation === 1) {
            updateContentCart();
          }      
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    
  
    //Function to refresh the cart UI quantity and total price
    function refreshCartUI(cart) {  
      document.querySelector('.text-total span').textContent = cart.item_count;
      updateIconHeaderQuantity(cart);
    }
  
    //Function to update icon header quantity
    function updateIconHeaderQuantity(cart) {
      const cartCount = cart.item_count;
      const cartElement = document.querySelectorAll(".icon-cart-number");
      if (cartElement) {
        cartElement.forEach(element => {
          element.textContent = cartCount.toString();
        });
      }
    }
  
    //function to close side cart when clicking outside of it and in close button
    overlay?.addEventListener('click', closeSideCart);
    closeBtn?.addEventListener('click', closeSideCart);

    // Delegación de eventos para el botón "Add to Cart"
    document.addEventListener('click', function(e) {
      const btnAdd = e.target.closest('.btn.btn--full.add-to-cart');
      const btnAddMobilePLP = e.target.closest('.button-add-to-cart .add-to-cart');
      if (btnAdd) {
        setTimeout(() => {
          openSideCart();
        }, 1000);
      };
      if (btnAddMobilePLP) {
        setTimeout(() => {
          openSideCart();
        }, 1000);
      };
    });
  
    // Open side cart when clicking on the cart icon
    openSideCartBtn?.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (sideCart?.classList.contains('hidden')) {
          openSideCart();
        }
      });
    });

    //Event listener for quantity btn
    itemsContainer.addEventListener('click', (e) => {
      const btnPlus = e.target.closest('.btn-quantity--increase');
      const btnMinus = e.target.closest('.btn-quantity--decrease');

      if(btnPlus) {
        const parentContainer = btnPlus.closest('.quantity-selector');
        let quantityElement = parentContainer.querySelector('#quantity-item-side-cart');
        let lineId = parseInt(quantityElement.getAttribute('data-id'), 10);
        let currentQuantity = parseInt(quantityElement.getAttribute('data-quantity'), 10);
        let quantity = currentQuantity + 1;
        quantityElement.setAttribute('data-quantity', quantity);
        quantityElement.textContent = quantity;
       
        updateCartItemQuantity(lineId, quantity, 0);

      }
      if(btnMinus) {
        const parentContainer = btnMinus.closest('.quantity-selector');
        let quantityElement = parentContainer.querySelector('#quantity-item-side-cart');
        let lineId = parseInt(quantityElement.getAttribute('data-id'), 10);
        let currentQuantity = parseInt(quantityElement.getAttribute('data-quantity'), 10);
        let quantity = currentQuantity - 1;

        if(quantity >= 1){
          quantityElement.setAttribute('data-quantity', quantity);
          quantityElement.textContent = quantity;
          updateCartItemQuantity(lineId, quantity, 0);
        }else if (quantity === 0){
          quantityElement.setAttribute('data-quantity', quantity);
          quantityElement.textContent = quantity;
          updateCartItemQuantity(lineId, 0, 1);
          setTimeout(() => {
            buildUpsellCarrousel();
          }, 1000);
        }

      }
    });  
  
    // Observer for detecting when #ps__widget is added to the DOM
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        const psWidget = document.querySelector('#ps__widget');
        if (psWidget) {
  
          if (sideCart?.classList.contains('open')) {
            psWidget.classList.add('hidden');
          } else {
            psWidget.classList.remove('hidden');
          }
  
          observer.disconnect();
        }
      });
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
});